/** URLs des Admin-Bereichs an einer Stelle, damit Listen, Suche und Detailseiten gleich verlinken. */
export const paths = {
  overview: '/admin',
  players: '/admin/players',
  player: (id: string) => `/admin/players/${id}`,
  teams: '/admin/teams',
  team: (id: string) => `/admin/teams/${id}`,
  chests: '/admin/chests',
  chest: (id: string) => `/admin/chests/${id}`,
  items: '/admin/items',
  item: (id: string) => `/admin/items/${encodeURIComponent(id)}`,
  betaCodes: '/admin/beta-codes',
  logs: '/admin/logs',
  stats: '/admin/stats',
  sortPlans: '/admin/sort-plans',
  sortPlan: (id: string) => `/admin/sort-plans/${id}`,
};

export type HitType = 'user' | 'team' | 'item' | 'chest';

export const pathFor = (type: HitType, id: string) =>
  type === 'user' ? paths.player(id) : type === 'team' ? paths.team(id) : type === 'item' ? paths.item(id) : paths.chest(id);
